import script from "./ProductPending.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPending.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPending.vue?vue&type=style&index=0&id=39f65560&scoped=true&lang=scss"

import exportComponent from "/home/forge/client.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f65560"]])

export default __exports__